import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import template from './paletteDialog.jsx';
import displayNames from '../displayNames';
var PaletteDialog = /*#__PURE__*/function (_React$Component) {
  function PaletteDialog(props) {
    var _this;
    _classCallCheck(this, PaletteDialog);
    _this = _callSuper(this, PaletteDialog, [props]);
    _this.initialPalette = _this.props.palette;
    var revertToInitial = function revertToInitial() {
      return _this.props.onPaletteChange(_this.initialPalette);
    };
    _this.onBackToPreset = function () {
      revertToInitial();
      _this.props.toggleChangeMode();
    };
    _this.onCancel = function () {
      revertToInitial();
      if (_.isFunction(_this.props.onClose)) {
        _this.props.onClose();
      }
    };
    return _this;
  }
  _inherits(PaletteDialog, _React$Component);
  return _createClass(PaletteDialog, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);
}(React.Component);
PaletteDialog.displayName = displayNames.PALETTE_DIALOG;
PaletteDialog.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  textKeys: PropTypes.shape({
    addColor: PropTypes.string,
    cancel: PropTypes.string,
    change: PropTypes.string,
    changeColors: PropTypes.string,
    choosePresetText: PropTypes.string,
    done: PropTypes.string,
    header: PropTypes.string,
    learnMore: PropTypes.string,
    myColors: PropTypes.string,
    presetDesigns: PropTypes.string,
    siteColors: PropTypes.string
  }),
  onHelp: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  addColor: PropTypes.func.isRequired,
  toggleChangeMode: PropTypes.func.isRequired,
  myColors: PropTypes.arrayOf(PropTypes.string).isRequired,
  changeMode: PropTypes.bool,
  chooseColor: PropTypes.func,
  onPreviewChange: PropTypes.func,
  onPaletteChange: PropTypes.func,
  colorSelectedIndex: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  mainColors: PropTypes.arrayOf(PropTypes.string)
};
PaletteDialog.defaultProps = {
  textKeys: {}
};
export default compose(PaletteDialog);